import "@/styles/output.css";
import "@/styles/index.css";
import "@/styles/variables.scss";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { processUtm } from "@/common/utm";

import(/* webpackPrefetch: true */ "core-js/stable");
import(/* webpackPrefetch: true */ "regenerator-runtime/runtime");

processUtm();

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.warn("No #root element found — skipping React bootstrap.");
} else {
  const root = createRoot(rootElement!);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
